import type { ComponentPropsWithRef, JSX } from 'react';

import { cn } from '@change/ds-utils';

import { memo } from '@change-corgi/core-react/core';
import { parseHtml } from '@change-corgi/core-react/html';

type Props = Omit<ComponentPropsWithRef<'div'>, 'ref'> & {
	aspectRatio?: string;
	embedHtml: string;
};

export const EmbeddedVideo = memo(
	({
		embedHtml,
		aspectRatio,
		className,
		style,
		ref,
		...rest
	}: Props & {
		ref?: React.RefObject<HTMLDivElement>;
	}): JSX.Element => {
		return (
			<div
				className={cn(
					'overflow-hidden [&_embed]:size-full [&_iframe]:size-full [&_object]:size-full [&_video]:size-full',
					className,
				)}
				style={aspectRatio ? { ...style, aspectRatio } : style}
				{...rest}
				ref={ref}
			>
				{parseHtml(embedHtml, {
					allowedTags: ['iframe'],
					allowedAttrs: ['allow', 'allowfullscreen', 'frameborder', 'scrolling'],
				})}
			</div>
		);
	},
);
